export type LanguageCatalogEntry = { code: string; label: string; flag: string };

export const LANGUAGE_CATALOG: LanguageCatalogEntry[] = [
    { code: "en", label: "English", flag: "🇺🇸" },
    { code: "es", label: "Spanish", flag: "🇪🇸" },
    { code: "fr", label: "French", flag: "🇫🇷" },
    { code: "de", label: "German", flag: "🇩🇪" },
    { code: "it", label: "Italian", flag: "🇮🇹" },
    { code: "pt", label: "Portuguese", flag: "🇵🇹" },
    { code: "zh", label: "Chinese", flag: "🇨🇳" },
    { code: "ja", label: "Japanese", flag: "🇯🇵" },
    { code: "ko", label: "Korean", flag: "🇰🇷" },
    { code: "ar", label: "Arabic", flag: "🇸🇦" },
    { code: "hi", label: "Hindi", flag: "🇮🇳" },
    { code: "bn", label: "Bengali", flag: "🇧🇩" },
    { code: "ur", label: "Urdu", flag: "🇵🇰" },
    { code: "ta", label: "Tamil", flag: "🇮🇳" },
    { code: "te", label: "Telugu", flag: "🇮🇳" },
    { code: "mr", label: "Marathi", flag: "🇮🇳" },
    { code: "gu", label: "Gujarati", flag: "🇮🇳" },
    { code: "kn", label: "Kannada", flag: "🇮🇳" },
    { code: "ml", label: "Malayalam", flag: "🇮🇳" },
    { code: "pa", label: "Punjabi", flag: "🇮🇳" },
    { code: "tr", label: "Turkish", flag: "🇹🇷" },
    { code: "fa", label: "Persian", flag: "🇮🇷" },
    { code: "he", label: "Hebrew", flag: "🇮🇱" },
    { code: "th", label: "Thai", flag: "🇹🇭" },
    { code: "vi", label: "Vietnamese", flag: "🇻🇳" },
    { code: "id", label: "Indonesian", flag: "🇮🇩" },
    { code: "ms", label: "Malay", flag: "🇲🇾" },
    { code: "fil", label: "Filipino", flag: "🇵🇭" },
    { code: "sw", label: "Swahili", flag: "🇰🇪" },
    { code: "am", label: "Amharic", flag: "🇪🇹" },
    { code: "zu", label: "Zulu", flag: "🇿🇦" },
    { code: "xh", label: "Xhosa", flag: "🇿🇦" },
    { code: "af", label: "Afrikaans", flag: "🇿🇦" },
    { code: "nl", label: "Dutch", flag: "🇳🇱" },
    { code: "sv", label: "Swedish", flag: "🇸🇪" },
    { code: "no", label: "Norwegian", flag: "🇳🇴" },
    { code: "da", label: "Danish", flag: "🇩🇰" },
    { code: "fi", label: "Finnish", flag: "🇫🇮" },
    { code: "pl", label: "Polish", flag: "🇵🇱" },
    { code: "cs", label: "Czech", flag: "🇨🇿" },
    { code: "sk", label: "Slovak", flag: "🇸🇰" },
    { code: "hu", label: "Hungarian", flag: "🇭🇺" },
    { code: "el", label: "Greek", flag: "🇬🇷" },
    { code: "ro", label: "Romanian", flag: "🇷🇴" },
    { code: "bg", label: "Bulgarian", flag: "🇧🇬" },
    { code: "uk", label: "Ukrainian", flag: "🇺🇦" },
    { code: "ru", label: "Russian", flag: "🇷🇺" },
    { code: "sr", label: "Serbian", flag: "🇷🇸" },
    { code: "hr", label: "Croatian", flag: "🇭🇷" },
    { code: "sl", label: "Slovenian", flag: "🇸🇮" },
    { code: "mk", label: "Macedonian", flag: "🇲🇰" },
    { code: "bs", label: "Bosnian", flag: "🇧🇦" },
    { code: "ka", label: "Georgian", flag: "🇬🇪" },
    { code: "hy", label: "Armenian", flag: "🇦🇲" },
    { code: "az", label: "Azerbaijani", flag: "🇦🇿" },
    { code: "kk", label: "Kazakh", flag: "🇰🇿" },
    { code: "uz", label: "Uzbek", flag: "🇺🇿" },
    { code: "mn", label: "Mongolian", flag: "🇲🇳" },
    { code: "et", label: "Estonian", flag: "🇪🇪" },
    { code: "lv", label: "Latvian", flag: "🇱🇻" },
    { code: "lt", label: "Lithuanian", flag: "🇱🇹" },
    { code: "ga", label: "Irish", flag: "🇮🇪" },
    { code: "cy", label: "Welsh", flag: "🇬🇧" },
    { code: "is", label: "Icelandic", flag: "🇮🇸" },
    { code: "mt", label: "Maltese", flag: "🇲🇹" },
    { code: "sq", label: "Albanian", flag: "🇦🇱" },
    { code: "eu", label: "Basque", flag: "🇪🇸" },
    { code: "gl", label: "Galician", flag: "🇪🇸" },
    { code: "ca", label: "Catalan", flag: "🇪🇸" }
];
